import type { Obj } from "@paroicms/anywhere-lib";
import { fetchQuery } from "../shared/http-client";
import { type Statistics, formatToStatistics } from "./statistics.formatter";

export interface RequestError {
  error: string;
}

export async function fetchStatisticsByReferenceAPI(
  tableId: number,
  options?: {
    startedAt: string;
    endedAt: string;
  },
): Promise<Statistics> {
  const { data } = await fetchQuery<Obj>(
    `stats/${tableId}${options ? `?started_at=${options.startedAt}&ended_at=${options.endedAt}` : ""}`,
  );
  return formatToStatistics(data);
}

export async function fetchDashboardStatisticsAPI(): Promise<Statistics> {
  const { data } = await fetchQuery<Obj>("stats/dashboard");
  return formatToStatistics(data);
}
